/* eslint-disable no-restricted-imports */
import { useState } from 'react';

import { Box, Checkbox, IconButton, TextField, Typography } from '@material-ui/core';
import { Check, Close, Edit } from '@material-ui/icons';

import { Skeleton } from '@mui/material';

import { useStyles } from './styles';

export function ServicesSection({
  additionalServices,
  loadingBudgetData,
  updateService,
  updateServicePrice,
}) {
  const classes = useStyles();

  const [editingServicePrice, setEditingServicePrice] = useState();
  const [tempServicePrice, setTempServicePrice] = useState();

  const handleServicePriceEdit = (servicoId, currentPrice) => {
    setEditingServicePrice(servicoId);
    setTempServicePrice(currentPrice);
  };

  const handleServicePriceSave = (servicoId) => {
    updateServicePrice(servicoId, tempServicePrice);
    setEditingServicePrice(null);
  };

  const handleServicePriceCancel = () => {
    setEditingServicePrice(null);
    setTempServicePrice(0);
  };

  return (
    <Box>
      <Box display='flex' justifyContent='space-between' alignItems='center' marginBottom={2}>
        <Typography variant='subtitle1' style={{ fontWeight: 600 }}>
          Serviços Adicionais
        </Typography>
      </Box>
      <Box maxHeight={300} overflow='auto'>
        {loadingBudgetData
          ? Array.from({ length: 2 }).map((_, index) => (
              <Box key={index} className={classes.servicoItem}>
                <Skeleton variant='circle' width={24} height={24} />
                <Skeleton variant='text' width='60%' style={{ marginLeft: 8 }} />
                <Skeleton variant='text' width={60} style={{ marginLeft: 'auto' }} />
              </Box>
            ))
          : (additionalServices || []).map((servico) => (
              <Box key={servico.id} className={classes.servicoItem}>
                <Checkbox
                  checked={servico.selected || false}
                  onChange={(e) => updateService(servico.id, e.target.checked)}
                  color='primary'
                />
                <Typography variant='body2' style={{ flex: 1 }}>
                  {servico.description}
                </Typography>
                {editingServicePrice === servico.id ? (
                  <Box display='flex' alignItems='center' gap={1}>
                    <TextField
                      type='number'
                      value={tempServicePrice}
                      onChange={(e) =>
                        setTempServicePrice(
                          parseFloat(e.target.value > 0 ? e.target.value : 0) || 0,
                        )
                      }
                      size='small'
                      style={{ width: 80 }}
                      inputProps={{ step: 0.01 }}
                    />
                    <IconButton size='small' onClick={() => handleServicePriceSave(servico.id)}>
                      <Check fontSize='small' style={{ color: '#4caf50' }} />
                    </IconButton>
                    <IconButton size='small' onClick={handleServicePriceCancel}>
                      <Close fontSize='small' style={{ color: '#f44336' }} />
                    </IconButton>
                  </Box>
                ) : (
                  <Box display='flex' alignItems='center' gap={1}>
                    <Typography variant='body2' style={{ fontWeight: 600, marginRight: 8 }}>
                      R$ {(servico.value || 0).toFixed(2)}
                    </Typography>
                    <IconButton
                      size='small'
                      onClick={() => handleServicePriceEdit(servico.id, servico.value)}
                    >
                      <Edit fontSize='small' />
                    </IconButton>
                  </Box>
                )}
              </Box>
            ))}
      </Box>
    </Box>
  );
}
